export default IconPlaceholder => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-placeholder" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 20.415a8 8 0 1 0 3 -15.415h-3" />
  <path d="M13 8l-3 -3l3 -3" />
  <path d="M7 17l4 -4l-4 -4l-4 4z" />
</svg>`;